import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5da5af7b"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "first-container"
};
const _hoisted_2 = {
  style: {
    "margin-left": "20px",
    "margin-bottom": "10px"
  }
};
const _hoisted_3 = {
  class: "auditMessage"
};
const _hoisted_4 = {
  class: "reject-info",
  style: {
    "font-size": "12px"
  }
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "margin-right": "20px"
  }
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "color": "red",
    "margin-top": "32px"
  }
}, "报名被驳回")], -1));

const _hoisted_6 = {
  class: "root-container"
};
const _hoisted_7 = {
  class: "second-container"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1,
  class: "img-container"
};
const _hoisted_10 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createBlock(_component_el_dialog, {
    modelValue: $data.dialogTableVisible,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dialogTableVisible = $event),
    title: "详情",
    width: "800px"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, _toDisplayString($props.rejectInfo.auditTime), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($props.rejectInfo.auditMessage), 1), _createVNode(_component_el_tooltip, {
      content: $props.rejectInfo.auditMessage,
      placement: "bottom",
      effect: "light"
    }, {
      default: _withCtx(() => [_withDirectives(_createElementVNode("p", null, ">", 512), [[_vShow, $props.rejectInfo.auditMessage.length > 31]])]),
      _: 1
    }, 8, ["content"])])]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.rejectInfo.applyFormDtos, item => {
      return _openBlock(), _createElementBlock("div", {
        class: "",
        key: item
      }, [item.type != 7 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("label", null, _toDisplayString(item.name) + "：", 1), _createElementVNode("span", null, _toDisplayString(item.value), 1)])) : _createCommentVNode("", true), item.type === 7 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("label", null, _toDisplayString(item.name) + "：", 1), _createElementVNode("img", {
        src: item.value,
        alt: ""
      }, null, 8, _hoisted_10)])) : _createCommentVNode("", true)]);
    }), 128))])])]),
    _: 1
  }, 8, ["modelValue"]);
}